var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_4879)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81513 1.12974C5.60928 0.839686 4.3409 0.963913 3.21425 1.48241C2.08759 2.00092 1.16823 2.88352 0.604208 3.98809C0.0401864 5.09266 -0.135667 6.35492 0.104965 7.57159C0.345598 8.78826 0.988712 9.88854 1.93074 10.6952C2.87278 11.502 4.0589 11.9681 5.29811 12.0187C6.53732 12.0693 7.75749 11.7013 8.76214 10.9741C8.98677 10.8115 9.03706 10.4976 8.87445 10.2729C8.71184 10.0483 8.39791 9.99801 8.17327 10.1606C7.35129 10.7556 6.35297 11.0567 5.33907 11.0153C4.32517 10.9739 3.3547 10.5925 2.58395 9.93247C1.8132 9.27243 1.28701 8.3722 1.09013 7.37674C0.893251 6.38128 1.03713 5.34853 1.4986 4.44479C1.96007 3.54105 2.71228 2.81892 3.63409 2.39469C4.5559 1.97046 5.59366 1.86882 6.58027 2.10614C7.56687 2.34346 8.44489 2.90592 9.07293 3.70295C9.49839 4.24288 9.79236 4.86917 9.93774 5.5325L7.23589 5.94915C6.95858 5.94915 6.73377 6.17396 6.73377 6.45127C6.73377 6.72859 6.95858 6.9534 7.23589 6.9534H10.3287C10.3941 6.9846 10.4673 7.00206 10.5446 7.00206C10.6219 7.00206 10.6951 6.9846 10.7606 6.9534H11.4966C11.7739 6.9534 11.9987 6.72859 11.9987 6.45127V2.1906C11.9987 1.91329 11.7739 1.68848 11.4966 1.68848C11.2192 1.68848 10.9944 1.91329 10.9944 2.1906L10.6478 4.43881C10.453 3.95451 10.1892 3.49702 9.86172 3.0814C9.09411 2.10725 8.02098 1.4198 6.81513 1.12974Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_4879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadBtn);
export default __webpack_public_path__ + "static/media/reload_btn.2c5e626d18eefaa84af9dfb19649cdb6.svg";
export { ForwardRef as ReactComponent };